import useMutation from "src/hooks/useMutation";
import {
  UPDATE_INVENTORY_ITEM_MUTATION,
  UPDATE_INTERNAL_WORK_ORDER_ITEM_MUTATION,
} from "src/constants/graphql/mutations";
import {
  getInternalWorkOrderFields,
} from "src/views/inventory/requests/CartItemFields";

const mutations = {
  inventoryRequest: UPDATE_INVENTORY_ITEM_MUTATION,
  internalWorkOrder: UPDATE_INTERNAL_WORK_ORDER_ITEM_MUTATION,
};

export default function useMarkStatusAs(orderType) {
  const mutation = mutations[orderType];
  const [updateItem, { loading }] = useMutation(mutation);

  const markAs = async item => {
    if (orderType === "inventoryRequest") {
      await updateItem({
        variables: {
          id: item.id,
          assetId: item.assetId,
          quantity: item.quantity,
          pickedStatus: true,
        },
      });
    } else if (orderType === "internalWorkOrder") {
      await updateItem({
        variables: {
          id: item.id,
          input: getInternalWorkOrderFields({
            ...item,
            pickedStatus: true,
          }),
        },
      });
    }
  };

  const markAsCompleted = async item => {
    if (orderType === "internalWorkOrder") {
      await updateItem({
        variables: {
          id: item.id,
          input: getInternalWorkOrderFields({
            ...item,
            completedStatus: true,
          }),
        },
      });
    }
  };

  return { markAs, markAsCompleted, loading };
}
